export const tableData = [
  {
    name: "awd",
    id: 1,
    miaoshu: "miashu",
    update_time: "123",
    create_time: "qwe"
  }
];
export const infoData = [
  {
    name: "awd",
    id: 1,
    miaoshu: "miashu",
    update_time: "123",
    create_time: "qwe"
  }
];
